export default __webpack_public_path__ + "static/kristi-16876bed7972c5a1d4b8354c1d9b330c.png";